/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-op-instruction.reducer';

export const PostOPInstructionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postOPInstructionEntity = useAppSelector(state => state.postOPInstruction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postOPInstructionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postOPInstruction.detail.title">PostOPInstruction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.id">Id</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.type">Type</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.type}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.instructions}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.active">Active</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.postOPInstruction.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{postOPInstructionEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPInstruction.surgery">Surgery</Translate>
          </dt>
          <dd>{postOPInstructionEntity.surgery ? postOPInstructionEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPInstruction.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{postOPInstructionEntity.anaesthesiologist ? postOPInstructionEntity.anaesthesiologist.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-op-instruction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-op-instruction/${postOPInstructionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostOPInstructionDetail;
